var render, staticRenderFns
import script from "./StudipProxiedCheckbox.vue?vue&type=script&lang=js&"
export * from "./StudipProxiedCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43042c5e')) {
      api.createRecord('43042c5e', component.options)
    } else {
      api.reload('43042c5e', component.options)
    }
    
  }
}
component.options.__file = "resources/vue/components/StudipProxiedCheckbox.vue"
export default component.exports